import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { GetUserInfoByUserIdResponse } from "../../models/officePosts.model";
import { GetUserInfoByUserId } from "../../services/officePosts.service";
import PermissionsTabs from "./components/PermissionsTabs";
import UserHeader from "./components/UserHeader";
import UserHeaderSkeleton from "./components/UserHeaderSkeleton";
import { useSelector } from "react-redux";

const UserDetail = () => {
  const [userInfo, setUserInfo] = useState<GetUserInfoByUserIdResponse>();
  const [updateService, setUpdateService] = useState("");
  const defaultPassword = useSelector((state: any) => state.password);

  const history = useHistory<{
    permissionUserId: number;
  }>();
  const userId =
    history?.location?.state?.permissionUserId !== undefined
      ? history?.location?.state?.permissionUserId
      : Number(window.localStorage.getItem("PermissionUserId"));

  const { mutate: GetUserInfoByUserIdMutate, isLoading } = useMutation(
    GetUserInfoByUserId,
    {
      onSuccess: (data: GetUserInfoByUserIdResponse) => {
        if (data) {
          setUserInfo(data);
        }
      },
      onError: () => {},
    }
  );

  useEffect(() => {
    GetUserInfoByUserIdMutate({
      id: userId,
    });
  }, [updateService]);

  return (
    <>
      <Grid container>
        {!isLoading ? (
          <Grid
            item
            xs={12}
            sx={{
              background: "#F9FAFC",
              width: "100%",
              border: "1px solid #EDEFEF",
              borderRadius: "5px",
            }}
          >
            <UserHeader
              userInfo={userInfo!}
              setUpdateService={setUpdateService}
              defaultPassword={defaultPassword}
            />
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              background: "#F9FAFC",
              width: "100%",
              border: "1px solid #EDEFEF",
              borderRadius: "5px",
            }}
          >
            <UserHeaderSkeleton />
          </Grid>
        )}
        <Grid item xs={12}>
          <PermissionsTabs userId={userId} />
        </Grid>
      </Grid>
    </>
  );
};

export default UserDetail;
